export class QuestionSettings {
    adaptive = false;
    adaptiveEnd = false;
    adaptiveStart = false;
    ajax = false;
    autoselectOptions = false;
    centeredWidth: number | null = null;
    debounce: number | null = null;
    dropdown = false;
    fullWidth = false;
    highlight = false;
    icon: string | null = null;
    lastpass = false;
    limit: number | null = null;
    order: string | null = null;
    orderProperty: string | null = null;
    required = false;
    showNotMatched = false;
    stepXhrTimeout: number | null = null;
    suggest = false;
    skipPrint = false;
    gaPage: string | null = null;
    gaPageData: string | null = null;

    constructor (props?: Partial<QuestionSettings>) {
        Object.assign(this, props || {});
    }
};
